import { Component, ChangeDetectorRef } from '@angular/core';
import { ReportService } from '@services/report.service';
import { startOfLocalDay } from '@classes/dates';

@Component({
  selector: 'app-duty-report',
  templateUrl: './duty-report.component.html',
  styleUrls: ['./duty-report.component.css'],
})
export class DutyReportComponent {
  loading = false;
  report: any = null;
  selectedDateOption: string;
  startDate: Date;
  endDate: Date;
  displayedColumns = ['vendor', 'paid', 'recovered', 'difference'];
  dateOptions = [
    { value: 'currentMonth', viewValue: 'CURRENT MONTH' },
    { value: 'previousMonth', viewValue: 'PREVIOUS MONTH' },
    { value: 'yearToDate', viewValue: 'YEAR TO DATE' },
    { value: 'previousYear', viewValue: 'PREVIOUS YEAR' },
    { value: 'customDateRange', viewValue: 'CUSTOM DATE RANGE' },
  ];

  constructor(public reportService: ReportService, public cdRef: ChangeDetectorRef) {}

  selectDateOption($event: any): void {
    this.selectedDateOption = $event.value;
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    switch (this.selectedDateOption) {
      case 'currentMonth':
        this.startDate = startOfLocalDay(new Date(year, month, 1));
        this.endDate = startOfLocalDay(new Date(year, month, day));
        break;
      case 'previousMonth':
        this.startDate = startOfLocalDay(new Date(year, month - 1, 1));
        this.endDate = startOfLocalDay(new Date(year, month, 0));
        break;
      case 'yearToDate':
        this.startDate = startOfLocalDay(new Date(year, 0, 1));
        this.endDate = startOfLocalDay(new Date(year, month, day));
        break;
      case 'previousYear':
        this.startDate = startOfLocalDay(new Date(year - 1, 0, 1));
        this.endDate = new Date(year - 1, 11, 31, 23, 59, 59);
        break;
    }

    if (this.selectedDateOption !== 'customDateRange') {
      this.getDutyReport();
    }
  }

  selectCustomDateRangeStart($event: any): void {
    this.startDate = $event.value;
  }

  selectCustomDateRangeEnd($event: any): void {
    this.endDate = $event.value;
    this.getDutyReport();
  }

  getDutyReport(): void {
    if (!this.startDate || !this.endDate) {
      return;
    }
    this.loading = true;
    this.reportService.getDutyReport(this.startDate, this.endDate).subscribe({
      next: (res: any) => {
        this.report = res?.data || null;
        this.loading = false;
        this.cdRef.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.cdRef.detectChanges();
      },
    });
  }
}
